export const isJson = (value: any): boolean => {
  try {
    JSON.parse(value)
  } catch (e) {
    return false
  }
  return true
}
